import { Helper } from '../Helper';
export class RawIteratorForEachBaseHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                this.each(sb.noPushValueOptions(innerOptions));
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorForEachBaseHelper.js.map
